"use strict";

angular.module('app.modals.manualValue', [])

    .controller('manualValueModalCtrl', ['$scope', 'close', 'f_User','Datapoints',
        function ($scope, close, f_User,  Datapoints) {

            //var userLevel =f_User.getUserLevel();
            $scope.close = function () {
                close();
            };

            $scope.init = function () {
                console.debug('Probably deprecated! manualValueModalCtrl initiated');
                $scope.Datapoints = Datapoints;
            }
            $scope.save = function () {
                close($scope.Datapoints);
            }

            $scope.init();
        }
    ])

    .factory('manualValueModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (Datapoints) {
            console.debug('Probably deprecated! manualValueModal called');

            return ModalService.showModal({
                templateUrl: "views/modals/editDatapoints.html",
                controller: 'manualValueModalCtrl',
                inputs: {
                    Datapoints: Datapoints
                }
            });


        }
    }]);
